import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import quantumFile from '../assets/MISSION10000_QUANTUM_Conference Proceedings.pdf';
import batteriesFile from '../assets/MISSION10000_BATTERIES_Conference Proceedings.pdf';
import bioeconomyFile from '../assets/MISSION10000_BIOECONOMY_Conference Proceedings.pdf';

const NanoPublications = () => (
  <Layout>
    <SEO title="Nano related scientific publications" />
    <h1>List of scientific papers and publications</h1>
    <h2>Conference Proceedings</h2>
    <ul>
      <li className="pdf-download-links__wrapper">
        <a className="pdf-download-links" href={ quantumFile } download>
          Download Misson 10000 Conference: Quantum
        </a>
      </li>
      <li className="pdf-download-links__wrapper">
        <a className="pdf-download-links" href={ batteriesFile } download>
          Download Misson 10000 Conference: Bateries
        </a>
      </li>
      <li className="pdf-download-links__wrapper">
        <a className="pdf-download-links" href={ bioeconomyFile } download>
          Download Misson 10000 Conference: The Bioeconomy
        </a>
      </li>
    </ul>
  </Layout>
);
export default NanoPublications;
